module.exports = __webpack_public_path__ + "img/busGray.916890c7.svg";